import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import BookQuote from "./BookQuote";
import useLoginCheck from "../util/useLoginCheck";
import { fetchBook, deleteBook, fetchBooks } from "../slice/bookSlice";
import { formatAuthors } from "../util/books";
import Spinner from "../util/Spinner";

const Book = () => {
  const dispatch = useDispatch();
  const { sid } = useParams();
  const { book, isLoading } = useSelector((state) => state?.books);
  const [isDeletingBook, setIsDeletingBook] = useState(false);
  const navigate = useNavigate();

  useLoginCheck();

  useEffect(() => {
    if (sid) {
      dispatch(fetchBook(sid));
    }
  }, [dispatch, sid]);

  const deleteBookHandler = async () => {
    if (window.confirm("Are you sure you want to delete this book?")) {
      try {
        setIsDeletingBook(true);
        dispatch(deleteBook(sid)).then(() => {
          setIsDeletingBook(false);
          fetchBooks();
          navigate(`/books?refresh=true`);
        });
      } catch (error) {
        console.log("error deleting book, message: ", error.message);
      } finally {
        setIsDeletingBook(false);
      }
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-4 md:p-6">
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className="flex justify-end gap-2 mb-4">
            <button
              className="btn-primary"
              onClick={() => navigate(`/books/${sid}/edit`, { state: { book } })}
            >
              Edit
            </button>
            <button
              className="btn-secondary"
              disabled={isDeletingBook}
              onClick={deleteBookHandler}
            >
              {isDeletingBook ? "Deleting..." : "Delete"}
            </button>
          </div>
          <dl className="card p-4 md:p-6 divide-y divide-stone-200">
            <div className="py-3 first:pt-0">
              <dt className="text-sm font-medium text-stone-500">Title</dt>
              <dd className="mt-1 text-stone-800">{book?.title}</dd>
            </div>
            <div className="py-3">
              <dt className="text-sm font-medium text-stone-500">Authors</dt>
              <dd className="mt-1 text-stone-800">
                {formatAuthors(book?.authors)}
              </dd>
            </div>
            <div className="py-3">
              <dt className="text-sm font-medium text-stone-500">
                Date Read
              </dt>
              <dd className="mt-1 text-stone-800">{book?.dateRead}</dd>
            </div>
            <div className="py-3">
              <dt className="text-sm font-medium text-stone-500">Rating</dt>
              <dd className="mt-1 text-stone-800">
                {book?.rating?.description}
              </dd>
            </div>
            <div className="py-3">
              <dt className="text-sm font-medium text-stone-500">Review</dt>
              <dd className="mt-1 text-stone-800 whitespace-pre-wrap">
                {book?.review}
              </dd>
            </div>
            <div className="py-3 last:pb-0">
              <dt className="text-sm font-medium text-stone-500">Quotes</dt>
              <dd className="mt-1">
                <ul className="list-disc pl-5 space-y-1 text-stone-800">
                  {book?.quotes?.map((quote) => (
                    <BookQuote key={quote?.sid} quote={quote} />
                  ))}
                </ul>
              </dd>
            </div>
          </dl>
        </>
      )}
    </div>
  );
};
export default Book;
